import { textFormatting } from '@yola/ws-sdk';
import isElementSelected from './is-element-selected';

const { wrappersTypes } = textFormatting.constants;

const isUnderlineSelected = () => isElementSelected(wrappersTypes.underline);

export default isUnderlineSelected;
